import { apiRequest } from './api';

/** Détail admin d’un ambassadeur (profil, filleuls, commissions). */
export async function fetchAdminAmbassadeurDetail(id: string) {
  const response = await apiRequest(`/admin/ambassadeurs/${encodeURIComponent(id)}`, {
    method: 'GET',
    withAuth: true,
  });
  return response.data;
}
